import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NavigateNextIcon(props: IconProps) {
    return <Icon {...props} iconKey={"navigate_next"}/>
}
